export var STATUS_UPLOAD_FAILURE = 'fileupload-failure';
export var STATUS_UPLOAD_PROCESSING = 'processing';
export var STATUS_FILETYPE_FAILURE = 'filetype-failure';
export var STATUS_UPLOAD_SUCCESS = 'success';
export var FILE_STATUS = {
  STATUS_UPLOAD_FAILURE: STATUS_UPLOAD_FAILURE,
  STATUS_UPLOAD_PROCESSING: STATUS_UPLOAD_PROCESSING,
  STATUS_FILETYPE_FAILURE: STATUS_FILETYPE_FAILURE,
  STATUS_UPLOAD_SUCCESS: STATUS_UPLOAD_SUCCESS
};